import { strategiesSelector } from "fleet/redux-store/strategies/selectors";
import { updateUiStrategyAction } from "fleet/redux-store/ui-state/strategy-v2/actions";
import { initialStrategy } from "fleet/redux-store/ui-state/strategy-v2/reducers";
import { denormalizeStrategy } from "fleet/view/strategy-v2/utils";
import get from "lodash/get";
import { connect } from "react-redux";
import { storesReady } from "redux-store";

import { StrategyV2DetailController } from "./detail-controller";

function mapStateToProps(state, props) {
  const id = get(props, "match.params.id", null);
  const viewType = get(props, "match.params.viewType", null);

  const { app, global, pages } = state;
  const strategies = strategiesSelector(state);
  const strategy = strategies[id];
  const storesLoaded = storesReady(
    global.applications,
    app.contentGroups,
    app.strategies,
    global.userContents,
  );
  const referenceDnStrategy =
    id === null || !storesLoaded
      ? initialStrategy
      : denormalizeStrategy(
          global.applications,
          global.userContents,
          app.contentGroups,
          strategy,
        );

  return {
    id,
    referenceDnStrategy,
    storesLoaded,
    viewType,
    dnStrategy: pages.strategyDetail.strategy,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setUiStrategy: (dnStrategy) => {
      dispatch(updateUiStrategyAction(dnStrategy));
    },
  };
}

const ConnectedStrategyV2DetailController = connect(
  mapStateToProps,
  mapDispatchToProps,
)(StrategyV2DetailController);

export { ConnectedStrategyV2DetailController };
